<h1 mat-dialog-title>Añadir nuevo Departamento</h1>
<mat-dialog-content [formGroup]="department_form">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-4">
        <mat-form-field appearance="outline">
          <mat-label>Nombre</mat-label>
          <input type="text" matInput formControlName="name" />
        </mat-form-field>
      </div>
      <div class="col-12 col-lg-8">
        <mat-form-field appearance="outline">
          <mat-label>Descripción</mat-label>
          <input type="text" matInput formControlName="description" />
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-checkbox formControlName="can_clock_outside_office">Puede fichar fuera de oficina</mat-checkbox>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button color="accent" [mat-dialog-close]="department_form.value" [disabled]="!department_form.valid" type="submit">
    <mat-icon style="margin-right: 10px">supervised_user_circle</mat-icon>
    Crear Departamento
  </button>
</mat-dialog-actions>
